import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormArray, AbstractControl, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { FormTemplateDataEntryService } from './../services/form-template-data-entry.service';
//import { ItemDataService } from './../services/item-data.service';
import { IDataEntryForm } from './../models/data-entry.model';
import { TextDictionaryService } from './../services/text-dictionary.service';
import textList from '../../assets/data/text-dictionary.json'
import { ZenplansTestDataProviderService } from './../services/zenplans-test-data-provider.service';

@Component({
  selector: 'app-dynamic-view',
  templateUrl: './dynamic-view.component.html',
  styleUrls: ['./dynamic-view.component.scss']
})
export class DynamicViewComponent implements OnInit {
  formResult: string = "no results yet";
  myFormGroup: FormGroup = new FormGroup({});
  myFormTemplate: IDataEntryForm;
  templateName;
  Id;
  showHelp = false;
  myTextList = textList;
  subscription;
  myItem = {};
  buttonText = "Back";
  currencySymbol ="&#163;"

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private ftService: FormTemplateDataEntryService, private dictService: TextDictionaryService,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private fb: FormBuilder,) {
    console.log("start constructor");
    this.activatedRoute.paramMap.subscribe(params => {
      this.templateName = params.get('templateName');
      this.Id = params.get('Id');
      
      console.log("end constructor");
    });
  }
  ngOnChanges() {
    console.log("start onchanges");
  }

  async ngOnInit() {
    console.log("start oninit");
    this.myFormTemplate = await this.ftService.getFormTemplateAsync(this.templateName);
    this.myItem = await this.zenplansTestDataProviderService.getItem(this.Id,this.myFormTemplate.sectionTitle);
    await this.getFields();
    // this.subscription = this.itemDataService.currentMessage.subscribe(message => {
    //   this.myItem = JSON.parse(message);
    //   this.getFields();
    // });
  };

  async getFields() {
    
    var objectKeys = Object.keys(this.myItem); //this.myItem is the json for this item from the data
    var objectValues = Object.values(this.myItem);
    //remove from the template any fields that are not in the data
    //make a list of missing fields
    var notFound:string[]=[];
    this.myFormTemplate.fields.forEach(kk => {
        var myValue = "";
        var index = objectKeys.findIndex(ff => ff.toLowerCase() === kk.fieldid.toLowerCase());
        if(index==-1){ //this template field is not in the data
          notFound.push(kk.fieldid);
        }
        else {
          //Found, but value is empty - we do not want to show it in the view
          if(objectValues[index]==null || objectValues[index]==""){
            notFound.push(kk.fieldid);
          }
        }
    });
    //remove the missing fields from the template. We don't want to show them in the view
    notFound.forEach(kk=>{
      let indexToRemove = this.myFormTemplate.fields.findIndex(jj=>jj.fieldid==kk);
      this.myFormTemplate.fields.splice(indexToRemove,1);
    })
    //connecting the tmplate fields with the stored fields
    this.myFormTemplate.fields.forEach(templateObject => {
      //if (!kk.nonData) {
        var myValue = "";
        var mySonList;
        var index = objectKeys.findIndex(ff => ff.toLowerCase() === templateObject.fieldid.toLowerCase());
        var fieldValue = objectValues[index] as string;
        //if (fieldValue && fieldValue.length>0) {
          myValue = fieldValue;
          switch (templateObject.inputtype) {
            case "formarray": {
              let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
              mySonList = objectValues[myIndex] as [];
              templateObject.sonListItems = mySonList;
              var myFormArray = [];
              mySonList.map(value=>{
                let myControl = this.fb.control(value);
                myFormArray.push(myControl);
              })
              this.myFormGroup.addControl(templateObject.fieldid, new FormArray(myFormArray));
              break;
            }
            case "formarraytwocolumns": {
              let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
              mySonList = objectValues[myIndex] as [{}];
              if(!mySonList){
                switch (templateObject.captions[0]) {
                  case "Name":
                    {
                      mySonList = [{Name:"",Email:""}];
                      break;
                    }
                  case "Income":
                    {
                      mySonList = [{Income:"",Description:""}];
                      break;
                    }
                  case "Expense":
                    {
                      mySonList = [{Expense:"",Description:""}];
                      break;
                    }
                }
                
              }
              templateObject.sonListItems = mySonList;
              var objectList = [];
              mySonList.map(group=>{
                let myGroup = this.fb.group(group);
                objectList.push(myGroup);
               });
               this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
               break;
            }
            case "formarraythreecolumns": {
              let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
              mySonList = objectValues[myIndex] as [{}];
              if(!mySonList){
                mySonList = [{name:"",email:"",percentage:""}];
              }
              templateObject.sonListItems = mySonList;
              var objectList = [];
              mySonList.map(group=>{
                let myGroup = this.fb.group(group);
                objectList.push(myGroup);
               });
               this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
               break;
            }
            case "formarrayfourcolumns": {
              let myIndex = objectKeys.findIndex(ff => ff.toLowerCase() == templateObject.fieldid.toLowerCase());
              mySonList = objectValues[myIndex] as [{}];
              if(!mySonList){
                mySonList = [{Name:"",Email:"",Percentage:"",IncomePercentage:""}];
              }
              templateObject.sonListItems = mySonList;
              var objectList = [];
              mySonList.map(group=>{
                let myGroup = this.fb.group(group);
                objectList.push(myGroup);
               });
               this.myFormGroup.addControl(templateObject.fieldid, new FormArray(objectList));
               break;
              }
            default: {
              this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue));
              break;
            }
          }
          //this.myFormGroup.addControl(templateObject.fieldid, new FormControl(myValue))
          
        //}
      //}
    });
    
    var yy = 0;
  }

  async getText(key: string) {
    let txt = await this.dictService.getText(key); //this.myTextList.find(kk=>kk.key==key).value;
    return txt;
  }

  goto(url: string) {
    this.router.navigate(['/' + url]);
  }

  onSubmit() {
    this.goto(this.myFormTemplate.url);
  }

}
